export const verifyEmailUpgradeAd = true
export const hamburgerMenu = false
